import {DataType} from '@wix/editor-platform-ooi-metadata-resolver'
import {SettingsParamType, createSettingsParams} from '@wix/tpa-settings'

export type ISettingsParams = {
  pageTitle: SettingsParamType.Text
  description: SettingsParamType.Text
  upcomingEventsTab: SettingsParamType.Text
  pastEventsTab: SettingsParamType.Text
  noUpcomingEvents: SettingsParamType.Text
  noUpcomingEventsLink: SettingsParamType.Text
  noUpcomingEventsLinkPageId: SettingsParamType.String
  pageTitleTag: SettingsParamType.Text
}

const settingsParams = createSettingsParams<ISettingsParams>({
  pageTitle: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_pageTitle'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('membersPage_pageTitle'),
      },
    }),
  },
  description: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_description'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('membersPage_description'),
      },
    }),
  },
  upcomingEventsTab: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_upcomingEventsTab'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('membersPage_upcomingEventsTab'),
      },
    }),
  },
  pastEventsTab: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_pastEventsTab'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('membersPage_pastEventsTab'),
      },
    }),
  },
  noUpcomingEvents: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_noUpcomingEvents'),
  },
  noUpcomingEventsLink: {
    type: SettingsParamType.Text,
    getDefaultValue: ({t}) => t('membersPage_noUpcomingEventsLink'),
    metadata: ({t}) => ({
      type: DataType.text,
      defaultValue: {
        type: 'static',
        value: t('membersPage_noUpcomingEventsLink'),
      },
    }),
  },
  noUpcomingEventsLinkPageId: {
    getDefaultValue: () => undefined,
  },
  pageTitleTag: {
    type: SettingsParamType.Text,
    getDefaultValue: () => 'h2',
  },
})

export default settingsParams
